<template>
  <div v-if="requestDone">
    <navBar />
    <NavBarSecond
      :pageType="'components.secondNavBar.server' | i18n"
      :backRoute="getBackRoute()"
    />
    <div no-gutters id="servers-main" class="my-5 mx-auto">
      <div id="infoBox" class="m-auto w-100 main">
        <div
          class="shadow-sm rounded-sm w-30 d-flex flex-column bg-primary p-4 pb-4 text-white nameBox"
        >
          <span class="font-weight-bold clientName pl-4">
            {{ this.client.nom }}</span
          >
          <span class="pb-2 pl-4"
            ><i class="icon map marker alternate " />{{
              this.client.pays + ", " + this.client.ville
            }}</span
          >
          <span v-if="this.$user.get().role == 'admin'">
            <router-link
              :to="'/clients/' + this.client.id"
              class="text-white pl-4"
            >
              <i class="icon external alternate" />
              <span> {{ "servers.clientPageLink" | i18n }} </span>
            </router-link>
          </span>
        </div>
      </div>

      <div v-if="requestDone" class="justify-content-center d-flex mt-4">
        <div class="bg-white shadow-sm rounded-lg p-4 w-100 main">
          <div v-if="isReady">
            <GenericBtnAdd class="ml-4 mt-3" @click="addServer" />
            <FormServerSection
              :isShown="show"
              :clientId="'' + client.id"
              @successed-request="close"
              v-on:canceled="close"
              id="FormServerSection"
            />
          </div>
          <ServerState
            :clientId="client.id"
            @doneLoading="
              () => {
                isReady = true;
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ServerState, NavBar, NavBarSecond, GenericBtnAdd } from "@/components";
import { FormServerSection } from "@/sections";

/**
 * @description Composante qui montre les serveurs d'un client
 * @author Benjamin Caron
 * @author Francine Jin
 * @author Alexandre Gallant
 * @author Kevin Dubé
 * @vue-data {Boolean} show - Définit si le modal est affiché ou non
 * @vue-data {Object} client - Les données du client
 * @vue-data {Boolean} requestDone - Si la requête est terminée
 */
export default {
  components: {
    ServerState,
    NavBar,
    NavBarSecond,
    FormServerSection,
    GenericBtnAdd
  },
  /**
   * @description Récupère les informations sur le client
   */
  beforeMount() {
    this.getClient();
  },
  data() {
    return {
      show: false,
      client: {},
      requestDone: false,
      isReady: false
    };
  },
  methods: {
    /**
     * @description Permet de fermer le modal
     */
    close() {
      this.show = false;
    },
    /**
     * @description Permet d'ouvrir le modal
     */
    addServer() {
      this.show = true;
    },
    /**
     * @description Fonction qui va chercher le client auprès de l'api
     */
    async getClient() {
      this.requestDone = false;
      try {
        await this.$api.getClient(this.$route.params.client_id).then(res => {
          this.client = res.data.data;
          this.requestDone = true;
        });
      } catch {
        this.$router.push("/404");
      }
    },
    /**
     * @description Fonction qui donne la bonne route de retour à la deuxième navbar
     */
    getBackRoute() {
      return this.$user.get().role == "admin"
        ? "/clients/" + this.client.id
        : "/dashboard";
    }
  }
};
</script>

<style scoped>
#infoBox {
  margin-top: 1% !important;
}
.clientName {
  font-size: 35px;
}

@media screen and (min-width: 1366px) {
  #servers-main {
    width: 1366px;
  }
}

@media screen and (max-width: 1025px) {
  #servers-main {
    width: 95%;
  }
}

@media screen and (max-width: 414px) {
  #servers-main {
    width: 100%;
  }
}

@media screen and (max-width: 1025px) {
  #infoBox {
    margin-top: 5% !important;
  }
  .nameBox {
    width: 100% !important;
  }
  .main {
    width: 100% !important;
  }
}

@media screen and (max-width: 700px) {
  .pl-4 {
    padding-left: 0 !important;
  }
  #infoBox {
    margin-top: 5% !important;
  }
  .main {
    width: 100% !important;
    padding-left: 0 !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
